import { useRef } from "react";
import { useReactMediaRecorder as useRecorder } from "react-media-recorder";
import { gameStorage } from "./gameIdentity";
import { getRecordingSession, retainCompletedRecording } from "./audioSession";

// Storage requires separate opt-in AND a current game/foreground-session grant.
export const useReactMediaRecorder = options => {
    const lease = useRef(null);
    // The recorder library otherwise labels every audio container as WAV,
    // even when Chrome actually emits WebM. Preserve the encoder's MIME type.
    const recorder = useRecorder({ ...options, blobPropertyBag: options.blobPropertyBag || {}, onStop: (url, blob) => {
        const started = lease.current;
        lease.current = null;
        if (started) void retainCompletedRecording(started, blob);
        return options.onStop?.(url, blob);
    } });
    return { ...recorder, startRecording: (...args) => {
        const gameId = gameStorage.getItem("pure_active_game") || "UNKNOWN";
        // Shared-device Bridge recordings may contain another person's voice.
        lease.current = getRecordingSession(gameId);
        return recorder.startRecording(...args);
    } };
};
